import React, { Component } from 'react'
import { connect } from 'react-redux'
import { imageSearch, gifSearch } from '../../actions/imageSearch'
import ImageSearch from '../../components/ImageSearch'
import { saveImageSearchModalImage, hideModal } from '../../actions/modals'
import { showNotification } from '../../actions/notifications'

const MAX_FILE_SIZE = 20000000

// used for add repo image modal (used to be used in set editor pre rich text)
// TODO clean out old GIF search stuff (this modal used to be used in old set editor and we experimented with GIF search)
class ImageSearchContainer extends Component {
  constructor(props) {
    super()
    this.handleNewImageSearch = this.handleNewImageSearch.bind(this)
    this.handleSelectImage = this.handleSelectImage.bind(this)
    this.handleFileUpload = this.handleFileUpload.bind(this)
    this.handleLoadMore = this.handleLoadMore.bind(this)
    this.handleGifSearch = this.handleGifSearch.bind(this)
    this.handleLoadMoreGifs = this.handleLoadMoreGifs.bind(this)

    let images = []
    if (props.imageSearchResults) {
      images = props.imageSearchResults
    }
    let searchTerm = ''
    if (props.imageSearchTerm) {
      searchTerm = props.imageSearchTerm
    }

    this.state = ({
      images,
      searchTerm,
      isSearching: false,
      noResults: false,
      count: 50,
      gifLimit: 10,
      offset: 0,
      errorMessage: null,

    })
  }

  async handleGifSearch(searchTerm) {
    const { gifLimit } = this.state
    const { gifSearch } = this.props
    this.setState({ isSearching: true, noResults: false })
    try {
      const {
        searchResults,
        resultCount,
        nextOffset,
      } = await gifSearch(searchTerm, gifLimit, 0)
      if (resultCount === 0) {
        this.setState({ noResults: true })
      }

      this.setState({
        isSearching: false,
        images: searchResults,
        searchTerm,
        offset: nextOffset,
      })
    } catch (error) {
      this.setState({
        isSearching: false,
      })
    }
  }

  async handleLoadMoreGifs() {
    const { searchTerm, gifLimit, offset } = this.state
    const { gifSearch } = this.props
    this.setState({ isSearching: true })
    try {
      const {
        searchResults,
        nextOffset,
      } = await gifSearch(searchTerm, gifLimit, offset)
      const { images } = this.state
      this.setState({
        isSearching: false,
        images: [...images, ...searchResults],
        offset: nextOffset,
      })
    } catch (error) {
      this.setState({ isSearching: false })
    }
  }

  async handleNewImageSearch(searchTerm) {
    const { count } = this.state
    const { imageSearch } = this.props
    this.setState({ isSearching: true, noResults: false, images: [] })
    try {
      const {
        searchResults,
        resultCount,
        nextOffset,
      } = await imageSearch(searchTerm, count, 0)
      if (resultCount === 0) {
        this.setState({ noResults: true })
      }
      this.setState({
        isSearching: false,
        images: searchResults,
        searchTerm,
        offset: nextOffset,
      })
    } catch (error) {
      this.setState({
        isSearching: false,
        errorMessage: 'Sorry we are having issues handling the high demand for our new image search feature! We are working to fix this as soon as possible.',
      })
    }
  }

  async handleLoadMore() {
    const {
      searchTerm, count, offset, images,
    } = this.state
    const { imageSearch } = this.props
    this.setState({ isSearching: true })
    try {
      const { searchResults, nextOffset } = await imageSearch(searchTerm, count, offset)
      this.setState({
        isSearching: false,
        images: [...images, ...searchResults],
        offset: nextOffset,
      })
    } catch (error) {
      this.setState({ isSearching: false })
    }
  }

  handleSelectImage(index) {
    const img = this.state.images[index]
    this.props.saveImageSearchModalImage(img.src, img.thumbnail)
  }

  handleFileUpload(e) {
    const fileList = e.target.files
    const file = fileList[0]
    if (file.size > MAX_FILE_SIZE) {
      this.props.hideModal()
      this.props.showNotification('Max image upload is 20mb', 'Cannot upload image', 'destroy')
    } else {
      const reader = new FileReader()
      reader.readAsDataURL(file)
      reader.onload = (event) => {
        this.props.saveImageSearchModalImage(event.target.result, event.target.result)
      }
    }
  }

  render() {
    let imageSearch = this.handleNewImageSearch
    if (this.props.isGif) {
      imageSearch = this.handleGifSearch
    }

    return (
      <div className='repoImageSearch-container'>
        <ImageSearch
          isSearching={this.state.isSearching}
          imageSearch={imageSearch}
          isGif={this.props.isGif}
          images={this.state.images}
          searchTerm={this.state.searchTerm}
          noResults={this.state.noResults}
          onImageSelected={this.handleSelectImage}
          handleFileUpload={this.handleFileUpload}
          loadMore={this.handleLoadMore}
          loadMoreGifs={this.handleLoadMoreGifs}
          errorMessage={this.state.errorMessage}
          disableGifs={this.props.disableGifs}
        />
      </div>
    )
  }
}

export default connect(
  () => ({
    // disableGifs:state.modals.disableGifs,

  }),
  {
    hideModal, showNotification, imageSearch, gifSearch, saveImageSearchModalImage,
  },
)(ImageSearchContainer)
